import { loanTransaction, loanTransactions } from '@monestry-dev/schema';

// export { getDepositData as getData } from '../../../redux/actions/data';

export const schemaArray = loanTransactions;
export const schemaTransaction = loanTransaction;

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// ACCOUNTDETAILS ----------------------------------------------------------------------------------------------------

export const colWidths = {
  date: 100, otherPartyIban: 150, description: 450,
};

// these are initialisation values for the fields with changeable contents
export const attrs = {
  name: 'accountName',
  // bankName: 'bankName',
  // iban: 'IBAN',
  // bic: 'BIC',
};
